import { prompt, type PromptDefinition } from './models';

export const REAL_ESTATE_ANALYST_PROMPTS = [
    prompt(
        'Assess value & use',
        'What property metrics are documented for this building, and where are the sources?',
        'Which buildings have comparable, source-backed property metrics available?'
    ),
    prompt(
        'Assess value & use',
        "Where are this building's key property metrics missing or inconsistent?",
        'Which buildings have missing or inconsistent metrics affecting portfolio analysis?'
    ),
    prompt(
        'Assess value & use',
        "What changes are documented in this building's occupancy or use over time?",
        'Compare documented occupancy or use changes across my buildings.'
    ),
    prompt(
        'Assess value & use',
        'Find property analysis data for this building relating to…',
        'Find property analysis data across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        "What capital expenditure assumptions appear in this building's reports?",
        'Compare documented capital expenditure assumptions across my buildings.'
    ),
    prompt(
        'Assess value & use',
        "What source dates limit comparisons using this building's records?",
        'Which buildings rely on outdated inputs for cross-building comparisons?'
    ),
    prompt(
        'Assess value & use',
        "What income or tenancy figures are available in this building's documents?",
        'Which buildings have comparable documented income or tenancy figures?'
    ),
    prompt(
        'Assess value & use',
        'Find historical property reports for this building from…',
        'Find historical property reports across my buildings from…',
        'prefill'
    ),
    prompt(
        'Assess value & use',
        "Which risks are identified in this building's investment or assessment reports?",
        'Compare documented investment risks across my buildings.'
    ),
    prompt(
        'Assess value & use',
        'Which assumptions explain differences between reports about this building?',
        'Which buildings have conflicting analytical assumptions across their reports?'
    ),
    prompt(
        'Assess value & use',
        'What further evidence would improve analysis of this building?',
        'Which buildings should be prioritised for additional analytical data collection?'
    ),
    prompt(
        'Assess value & use',
        "Compare this building's documented metrics for…",
        'Compare source-backed metrics across my buildings for…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
